import { render, staticRenderFns } from "./energyEfficiency.vue?vue&type=template&id=349e96e2&scoped=true"
import script from "./energyEfficiency.vue?vue&type=script&lang=js"
export * from "./energyEfficiency.vue?vue&type=script&lang=js"
import style0 from "./energyEfficiency.vue?vue&type=style&index=0&id=349e96e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349e96e2",
  null
  
)

export default component.exports